<h1 mat-dialog-title *ngIf="!isLoading" xmlns="http://www.w3.org/1999/html">Edit Airport Overview</h1>
<div id="spinnerContainer" *ngIf="isLoading">
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</div>
<div *ngIf="!isLoading">
  <mat-dialog-content [formGroup]="formGroup">
    <fieldset class="fieldset-container">
      <legend>Airport Title</legend>
      <p>
        <mat-form-field class="inputs">
          <input matInput
                 placeholder="Airport Name *"
                 formControlName="title">
        </mat-form-field>
      </p>
      <p>
        <mat-form-field class="inputs">
          <input matInput
                 placeholder="ICAO ID"
                 formControlName="icaoId">
        </mat-form-field>
      </p>
    </fieldset>
    <fieldset class="fieldset-container" style="padding-bottom: 5px">
      <legend>Airport Address</legend>
      <!--style="padding-left: 0; padding-right: 0; padding-bottom: 0"-->
      <!--style="margin-left: 0; margin-right: 0; margin-bottom: 0"-->
      <h2></h2>
      <p>
        <mat-form-field class="inputs">
          <input matInput
                 placeholder="Street 1 *"
                 formControlName="street1">
        </mat-form-field>
      </p>
      <p>
        <mat-form-field class="inputs">
          <input matInput
                 placeholder="Street 2"
                 formControlName="street2">
        </mat-form-field>
      </p>
      <p class="input address_line_row">
        <mat-form-field class="address_row_item cityField">
          <input matInput
                 placeholder="City *"
                 formControlName="city">
        </mat-form-field>
        <mat-form-field *ngIf="states.length" class="address_row_item">
          <mat-select formControlName="stateProvince" placeholder="Select State *">
            <mat-option value="">None</mat-option>
            <mat-option *ngFor="let state of states" value="{{state.stateCode}}">{{state.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="!states.length" class="address_row_item">
          <input matInput
                 placeholder="Enter State"
                 formControlName="stateProvince">
        </mat-form-field>
        <mat-form-field class="address_row_item">
          <input matInput
                 placeholder="{{postalCodePlaceHolder}}"
                 formControlName="postalCode">
        </mat-form-field>
        <mat-form-field>
          <mat-select [id]="countrySelectId" formControlName="country" placeholder="Select Country"
                      (selectionChange)="countryChange($event)">
            <mat-option value="">None</mat-option>
            <mat-option *ngFor="let country of countries" value="{{country.countryCodeIso2.trim()}}">
              {{country.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </p>
    </fieldset>
    <fieldset class="fieldset-container">
      <legend>Contact and Website</legend>
      <p class="inputs">
        <mat-form-field id="phoneField">
          <input #phone
                 matInput
                 placeholder="Phone"
                 formControlName="phone"
                 maxlength="14"
                 (blur)="phoneFieldBlur('phone')"
                 (keyup)="phoneFieldKeyUp($event, 'phone', phone)">
        </mat-form-field>
      </p>
      <p class="inputs">
        <mat-form-field id="websiteField">
          <input matInput
                 placeholder="Website"
                 formControlName="webAddress">
        </mat-form-field>
        <mat-form-field id="emailField">
          <input matInput
                 placeholder="Email"
                 formControlName="email">
        </mat-form-field>
      </p>
    </fieldset>

    <fieldset class="fieldset-container">
      <legend>Other</legend>
      <p class="inputs">
        <mat-form-field id="timezoneField">
          <mat-select [id]="timezoneSelectId" formControlName="timezone" placeholder="Select Timezone"
                      (selectionChange)="timezoneChange($event)">
            <mat-option value="">None</mat-option>
            <mat-option *ngFor="let timezone of timezones" value="{{timezone}}">
              {{timezone}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </p>
    </fieldset>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="submit-button mat-raised-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="close()">Cancel</button>
  </mat-dialog-actions>
</div>
